import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, DefaultSelect, ToggleButton } from 'ui-kit-takeat';

import {
  IconUtensils,
  IconMotorcycle,
  IconQrCode,
  IconChevronDown,
  Switch,
  IconMenu,
} from 'takeat-design-system-ui-kit';
import ArrowClick from '~/assets/img/arrow-red.svg';
import { FaExclamationTriangle, FaAngleDown, FaTrash } from 'react-icons/fa';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useAuth } from '~/context/AuthContext';
import { useOrder } from '~/context/orderContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FiCopy, FiX } from 'react-icons/fi';
import { useTables } from '~/context/TablesContext';
import { toJpeg } from 'html-to-image';
import { useDeliveryOpeningHour } from '~/context/DeliveryOpeningHour';
import ImgToPrint from '../ImgToPrint';
import logo from '../../assets/img/logo_red.png';
import {
  Badge,
  ButtonsDiv,
  Container,
  HeaderButton,
  Logo,
  RightButtonsDiv,
  UserName,
  StatusButtonsArea,
  StatusButton,
  StatusCircle,
  ErrorDeliveryNotConfigured,
  StatuaSquare,
  TakeatIconStyled,
  TakeatLogoStyled,
} from './styles';
import WhatsappButton from './Whatsapp/WhatsappButton/index';

export const NewHeader = ({ isSidebarOpen }) => {
  const {
    changeRestaurantStatus,
    notificationsOpen,
    getUser,
    signOut,
    hasAScheduleBeenConfigured,
  } = useAuth();

  const {
    eventToEdit,
    handleDeleteEvent,
    deleteHoursInfos,
    isSetHourModalOpenedAtHeader,
    isModalDeleteOpened,
    handleEditOpeningHoursData,
    handleSaveOpeningHoursData,
    isDeliveryActive,
    changeEventDeliveryActive,
    isWithdrawalActive,
    changeEventWithdrawalActive,
    initialHour,
    setInitialHour,
    finalHour,
    setFinalHour,
    timeSlots,
    toggleModalDelete,
    toogleSetHourModalAtHeader,
    setIsModalDeleteOpened,
    toggleEditEventHeader,
    hasACurrentSchedule,
  } = useDeliveryOpeningHour();

  const user = getUser() || {};
  const { pendingBaskets } = useOrder();
  const basketCount =
    pendingBaskets.filter((basket) => basket.table.table_type === 'delivery')
      .length || 0;

  const { tableMenu } = useTables();

  const [opened, setOpened] = useState(user.opened);
  const [deliveryOpened, setDeliveryOpened] = useState(
    user.delivery_info?.is_delivery_active
  );
  const [withdrawalOpened, setWithdrawalOpened] = useState(
    user.delivery_info?.is_withdrawal_active
  );
  const [ifoodOpen, setIfoodOpen] = useState(user.ifood_open);
  const [newsRead, setNewsRead] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:newsRead'))
  );
  const history = useHistory();
  const [codeCopyed, setCodeCopyed] = useState(false);
  const [isModalQrcodeOpened, setIsModalQrcodeOpened] = useState(false);

  useEffect(() => {
    if (user) {
      setOpened(user.opened ?? false);
      setDeliveryOpened(user.delivery_info?.is_delivery_active);
      setWithdrawalOpened(user.delivery_info?.is_withdrawal_active);
    }
  }, [user]);

  const inputRef = useRef(null);
  const inputDeliveryRef = useRef(null);
  const imgRef = useRef(null);

  const tableUrl = tableMenu
    ? `${tableMenu.table_code?.url}?q=${Date.now()}`
    : '';

  const toggleModalQrcode = () => {
    setIsModalQrcodeOpened(!isModalQrcodeOpened);
    setCodeCopyed(false);
  };

  function copyUrlCode() {
    const textoCopiado = inputRef.current;
    textoCopiado.select();
    textoCopiado.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setCodeCopyed(true);
  }

  function copyDeliveryUrlCode() {
    const textoCopiado = inputDeliveryRef.current;
    textoCopiado.select();
    textoCopiado.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setCodeCopyed(true);
  }

  async function handleRestaurantStatusChange() {
    const response = await changeRestaurantStatus({
      opened: !opened,
      is_delivery_active: !!deliveryOpened,
      is_withdrawal_active: !!withdrawalOpened,
      ifood_open: !!ifoodOpen,
    });

    const { is_delivery_active, is_withdrawal_active } = response.delivery_info;

    setOpened(response.opened);
    setDeliveryOpened(is_delivery_active);
    setWithdrawalOpened(is_withdrawal_active);
  }

  const downloadPng = useCallback(() => {
    if (imgRef.current === null) {
      return;
    }

    toJpeg(imgRef.current, { cacheBust: true, fontEmbedCSS: false })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'cardapio_digital_takeat.jpg';
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [imgRef]);

  useEffect(() => {
    if (!notificationsOpen) {
      setNewsRead(JSON.parse(localStorage.getItem('@gddashboard:newsRead')));
    }
  }, [notificationsOpen]);

  const [showWdButton, setShowWdButton] = useState(false);
  const [showGdButton, setShowGdButton] = useState(false);

  function handleGoToConfigPage() {
    toggleEditEventHeader();
  }

  const handleClickOutside = (event) => {
    if (wdButtonRef.current && !wdButtonRef.current.contains(event.target)) {
      setShowWdButton(false);
    }
  };
  const wdButtonRef = useRef(null);

  useEffect(() => {
    if (showWdButton) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showWdButton]);

  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    if (clickCount === 3) {
      handleTripleClick();
      setClickCount(0); // Resetar o contador após detectar os 3 cliques
    }

    const timer = setTimeout(() => {
      setClickCount(0); // Resetar o contador se o tempo limite for atingido
    }, 500); // Define o intervalo para considerar os cliques (em ms)

    return () => clearTimeout(timer);
  }, [clickCount]);

  const handleTripleClick = () => {
    signOut();
  };

  const page = window.location.pathname;
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {page === '/delivery/orders' && !hasAScheduleBeenConfigured && (
        <ErrorDeliveryNotConfigured>
          <FaExclamationTriangle color="#FFA814" size={31} />
          <span>
            Há <strong>configurações pendentes</strong> na página
            &quot;Funcionamento&quot; que podem prejudicar sua operação.
          </span>
          <Button
            title="Configurar agora"
            buttonColor="#2EC9B7"
            onClick={() => history.push('/delivery/opening-hours')}
          />
        </ErrorDeliveryNotConfigured>
      )}

      <Container>
        <Modal
          isOpen={isSetHourModalOpenedAtHeader}
          toggle={toogleSetHourModalAtHeader}
          onClosed={deleteHoursInfos}
        >
          <ModalBody>
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {user?.only_delivery ? (
                  <span style={{ fontSize: 22, fontWeight: 'bold' }}>
                    Configuração de Delivery atual
                  </span>
                ) : (
                  <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                    Configuração de Delivery/ Retirada atual
                  </span>
                )}

                <FiX
                  size={21}
                  color="#767676"
                  onClick={toogleSetHourModalAtHeader}
                  cursor="pointer"
                />
              </div>
              <p style={{ fontSize: 16, fontWeight: 'bold' }}>
                {`${eventToEdit?.day}`}{' '}
                {initialHour && `- ${initialHour?.label}`}{' '}
                {finalHour && `até ${finalHour?.label}`}
              </p>
              {hasACurrentSchedule && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    marginTop: 20,
                  }}
                >
                  <StatuaSquare active={isDeliveryActive}>
                    <ToggleButton
                      value={isDeliveryActive}
                      onClick={changeEventDeliveryActive}
                    />
                    <span>
                      {isDeliveryActive
                        ? 'Delivery Aberto'
                        : 'Delivery Fechado'}
                    </span>
                  </StatuaSquare>
                  <StatuaSquare active={isWithdrawalActive}>
                    <ToggleButton
                      value={isWithdrawalActive}
                      onClick={changeEventWithdrawalActive}
                    />
                    <span>
                      {isWithdrawalActive
                        ? 'Retirada Aberto'
                        : 'Retirada Fechado'}
                    </span>
                  </StatuaSquare>
                </div>
              )}

              <hr />
              <div>
                <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                  Edite o horário, caso necessário:
                </span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      color: '#6c6c6c',
                      fontSize: 16,
                      marginRight: '8px',
                    }}
                  >
                    Das
                  </span>
                  <DefaultSelect
                    options={timeSlots}
                    onChange={(v) => setInitialHour(v)}
                    controlStyles={{ width: 150 }}
                    containerStyles={{ width: '33%' }}
                    defaultValue={initialHour}
                  />
                  <span
                    style={{ color: '#6c6c6c', fontSize: 16, margin: '0 8px' }}
                  >
                    até
                  </span>
                  <DefaultSelect
                    options={timeSlots}
                    onChange={(v) => setFinalHour(v)}
                    controlStyles={{ width: 150 }}
                    containerStyles={{ width: '33%' }}
                    defaultValue={finalHour}
                  />
                  {hasACurrentSchedule && (
                    <FaTrash
                      color="#FF2C3A"
                      size={23}
                      cursor="pointer"
                      style={{ marginLeft: 8 }}
                      onClick={toggleModalDelete}
                    />
                  )}
                </div>
              </div>
              <hr />

              <Modal isOpen={isModalDeleteOpened} toggle={toggleModalDelete}>
                <ModalBody>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                      {`${eventToEdit?.day}`}{' '}
                      {initialHour && `- ${initialHour?.label}`}{' '}
                      {finalHour && `até ${finalHour?.label}`}
                    </span>
                    <FiX
                      size={21}
                      color="#767676"
                      onClick={toogleSetHourModalAtHeader}
                      cursor="pointer"
                    />
                  </div>

                  <hr />
                  <p
                    style={{
                      fontSize: 18,
                      fontWeight: 'bold',
                      color: '#4d4d4c',
                    }}
                  >
                    Tem certeza que deseja excluir o horário cadastrado?
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 20,
                    }}
                  >
                    <Button
                      title="Cancelar"
                      inverted
                      buttonColor="#FF2C3A"
                      onClick={() => setIsModalDeleteOpened(false)}
                    />
                    <Button
                      title="Excluir"
                      buttonColor="#FF2C3A"
                      onClick={handleDeleteEvent}
                    />
                  </div>
                </ModalBody>
              </Modal>
            </>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 20,
              }}
            >
              <Button
                title="Cancelar"
                inverted
                buttonColor="#FF2C3A"
                onClick={() => {
                  toogleSetHourModalAtHeader();
                }}
              />
              <Button
                title={eventToEdit ? 'Salvar' : 'Adicionar'}
                buttonColor="#2EC9B7"
                onClick={
                  eventToEdit
                    ? handleEditOpeningHoursData
                    : handleSaveOpeningHoursData
                }
              />
            </div>
          </ModalBody>
        </Modal>
        <ButtonsDiv>
          {!user.only_delivery && page !== '/operation' && (
            <HeaderButton onClick={() => history.push('/operation')}>
              <IconUtensils />
              <span>Operação</span>
            </HeaderButton>
          )}
          {page === '/operation' && (
            <HeaderButton onClick={() => history.push('/search')}>
              <IconMenu />
              <span>Menu</span>
            </HeaderButton>
          )}
          {(user.delivery_info?.is_delivery_allowed ||
            user.delivery_info?.is_withdrawal_allowed) &&
            user.access !== 'pdv' && (
              <HeaderButton onClick={() => history.push('/delivery/orders')}>
                <IconMotorcycle />
                <span>Delivery</span>

                {basketCount > 0 && <Badge>{basketCount}</Badge>}
              </HeaderButton>
            )}
          <HeaderButton onClick={toggleModalQrcode}>
            <IconQrCode />
            <span>Cardápio</span>
          </HeaderButton>

          {user.use_wpp && <WhatsappButton />}

          <UserName isSidebarOpen={isSidebarOpen}>{user.fantasy_name}</UserName>
        </ButtonsDiv>

        <TakeatLogoStyled onClick={() => setClickCount((state) => state + 1)} />

        <TakeatIconStyled onClick={() => setClickCount((state) => state + 1)} />

        <RightButtonsDiv style={{ position: 'relative' }}>
          <StatusButtonsArea>
            <HeaderButton
              onClick={() =>
                window.open(
                  `https://app.getdemo.com.br/d/9b7d53d7-8b9a-4095-94f8-1fd8bd14a21c?email=${user.restaurant_email}`,
                  '_blank'
                )
              }
            >
              <img
                src={ArrowClick}
                alt="icone de clique"
                style={{
                  width: 13,
                  height: 24,
                }}
              />
              <span>Tutorial</span>
            </HeaderButton>
            {user.only_pdv &&
              !user.only_qrcode(
                <StatusButton opened={opened}>
                  <span>Garçom Digital</span>
                  <ToggleButton
                    onClick={handleRestaurantStatusChange}
                    value={opened}
                  />
                </StatusButton>
              )}

            {user.only_delivery && user.access !== 'pdv' && (
              <>
                <StatusButton
                  opened={deliveryOpened}
                  onClick={handleGoToConfigPage}
                >
                  <span>Delivery</span>
                  <StatusCircle opened={deliveryOpened}>
                    {deliveryOpened ? 'ON' : 'OFF'}
                  </StatusCircle>
                </StatusButton>
                <StatusButton
                  opened={withdrawalOpened}
                  onClick={handleGoToConfigPage}
                >
                  <span>Retirada</span>
                  <StatusCircle opened={withdrawalOpened}>
                    {withdrawalOpened ? 'ON' : 'OFF'}
                  </StatusCircle>
                </StatusButton>
              </>
            )}

            {!user.only_delivery && !user.only_pdv && user.access !== 'pdv' && (
              <>
                {user?.delivery_info?.is_delivery_allowed && (
                  <>
                    <StatusButton
                      style={{
                        position: 'relative',
                      }}
                      onClick={handleGoToConfigPage}
                      opened={deliveryOpened}
                      onMouseEnter={() => setShowWdButton(true)}
                    >
                      <IconChevronDown
                        style={{
                          transform: showWdButton && 'rotateX(180deg)',
                        }}
                      />
                      <span>Delivery</span>
                      <StatusCircle opened={deliveryOpened}>
                        {deliveryOpened ? 'ON' : 'OFF'}
                      </StatusCircle>
                      {showWdButton && (
                        <StatusButton
                          opened={withdrawalOpened}
                          style={{
                            position: 'absolute',
                            top: 41,
                            right: 0,
                            zIndex: 100000,
                          }}
                          onClick={handleGoToConfigPage}
                          onMouseLeave={() => setShowWdButton(false)}
                          ref={wdButtonRef}
                        >
                          <span>Retirada</span>
                          <StatusCircle opened={withdrawalOpened}>
                            {withdrawalOpened ? 'ON' : 'OFF'}
                          </StatusCircle>
                        </StatusButton>
                      )}
                    </StatusButton>
                  </>
                )}
                {!user.only_qrcode && (
                  <>
                    <StatusButton
                      opened={opened}
                      onMouseEnter={() => {
                        setShowWdButton(false);
                        setShowGdButton(true);
                      }}
                      onMouseLeave={() => setShowGdButton(false)}
                    >
                      <span>Garçom Digital</span>
                      <Switch
                        onChange={handleRestaurantStatusChange}
                        checked={opened}
                      />
                    </StatusButton>
                    {showGdButton && (
                      <StatusButton
                        opened={opened}
                        style={{
                          position: 'absolute',
                          top: 41,
                          right: 0,
                        }}
                      >
                        <span>
                          {opened
                            ? 'Pedido via QR Code ativo'
                            : 'Pedido via QR Code inativo'}
                        </span>
                        <StatusCircle opened={opened}>
                          {opened ? 'ON' : 'OFF'}
                        </StatusCircle>
                      </StatusButton>
                    )}
                  </>
                )}
              </>
            )}
          </StatusButtonsArea>
          {user.is_pdv && (
            <Button
              title="Sair"
              inverted
              containerStyles={{ height: 40 }}
              onClick={signOut}
            />
          )}
        </RightButtonsDiv>

        <Modal isOpen={isModalQrcodeOpened} toggle={toggleModalQrcode}>
          <ModalHeader>
            <strong style={{ fontSize: 16 }}>Cardápio Digital</strong>
          </ModalHeader>
          <ModalBody>
            <p>
              Compartilhe seu Cardápio em suas redes sociais e Whatsapp clicando
              no ícone &quot;Copiar&quot; <FiCopy color="FF2C3A" /> . Salve a
              imagem ou copie o link. Aproveite!
            </p>

            {(user?.delivery_info?.is_delivery_allowed ||
              user?.delivery_info?.is_withdrawal_allowed) && (
              <div
                style={{
                  marginBottom: '16px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',

                    width: '100%',
                  }}
                >
                  <strong>Cardápio Digital (PEDIDOS DELIVERY)</strong>
                  <FiCopy
                    color="FF2C3A"
                    onClick={copyDeliveryUrlCode}
                    size={18}
                    style={{ cursor: 'pointer', marginLeft: 8 }}
                    title="Copiar link"
                  />
                </div>

                <input
                  id="url-delivery"
                  ref={inputDeliveryRef}
                  value={`https://pedido.takeat.app/${
                    user.nickname ? user.nickname : user.name
                  }`}
                  type="Text"
                  style={{ border: 'none', width: '80%' }}
                />
              </div>
            )}

            <div
              style={{
                marginBottom: '16px',
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',

                  alignItems: 'center',

                  width: '100%',
                }}
              >
                <strong>Cardápio Digital (SOMENTE VISUALIZAÇÃO)</strong>

                <FiCopy
                  color="FF2C3A"
                  onClick={copyUrlCode}
                  size={18}
                  style={{ cursor: 'pointer', marginLeft: 8 }}
                  title="Copiar link"
                />
              </div>

              {tableMenu && (
                <input
                  id="url-qrcode"
                  ref={inputRef}
                  value={`https://cardapio.takeat.app/${
                    user.nickname ? user.nickname : user.name
                  }`}
                  type="Text"
                  style={{ border: 'none', width: '80%' }}
                />
              )}
            </div>

            {tableMenu && (
              <>
                <ImgToPrint
                  ref={imgRef}
                  imgSrc={tableUrl}
                  tableMenu={tableMenu}
                />

                <Button
                  width="100%"
                  containerStyles={{ marginTop: 10 }}
                  onClick={downloadPng}
                  title="Baixar imagem"
                />
              </>
            )}
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};
